import { useEffect, useRef } from 'react';
import { getIncomingVerificationStatus } from '../utils/addressVerification';

const useInitialAddressVerification = ({
  initialAddress,
  countryCode,
  lookupField,
  requireValidation,
  resolvedAddressForm,
  setValidationServiceError,
  setCustomError = null,
  setShowValidationSuggestions,
  setValidationTriggerSource,
  setValidationTrigger
}) => {
  const initialVerificationAttemptedRef = useRef(null);

  useEffect(() => {
    if (!initialAddress) {
      initialVerificationAttemptedRef.current = null;
      return;
    }

    if (!resolvedAddressForm?.addressElements?.length || !requireValidation) {
      return;
    }

    if (getIncomingVerificationStatus(initialAddress) !== 'unverified') {
      return;
    }

    const lookupValueForValidation = String(
      initialAddress?.[lookupField] || initialAddress?.address1 || ''
    ).trim();

    if (!lookupValueForValidation) {
      return;
    }

    const attemptKey = JSON.stringify({
      countryCode,
      lookupField,
      initialAddress
    });

    if (initialVerificationAttemptedRef.current === attemptKey) {
      return;
    }

    initialVerificationAttemptedRef.current = attemptKey;
    setValidationServiceError(null);
    if (setCustomError) {
      setCustomError(null);
    }
    setShowValidationSuggestions(false);
    setValidationTriggerSource('initial');
    setValidationTrigger((previousValue) => previousValue + 1);
  }, [
    countryCode,
    initialAddress,
    lookupField,
    requireValidation,
    resolvedAddressForm,
    setCustomError,
    setShowValidationSuggestions,
    setValidationServiceError,
    setValidationTrigger,
    setValidationTriggerSource
  ]);
};

export default useInitialAddressVerification;
